import {Component, OnDestroy, OnInit, signal, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ConfirmationService, MessageService} from "primeng/api";
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {SegnalazioniService} from "../../../services/segnalazioni.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {UserService} from "../../../services/user.service";
import {AreeCompetenzaService} from "../../../services/areeCompetenza.service";
import {TipiSegnalazioneService} from "../../../services/tipiSegnalazione.service";
import {ComuniService} from "../../../services/comuni.service";
import {ComuneDTO} from "../../../models/comune.model";
import {Subject, takeUntil} from "rxjs";
import {Segnalazione_Firestore} from "../../../models/firestore/segnalazioneFirestore.model";
import {environment} from "../../../../environments/environment";
import {Intervento_Firestore} from "../../../models/firestore/interventoFirestore.model";
import {AreaCompetenza, AreaCompetenzaEnum} from "../../../models/areaCompetenza.model";
import {TipoSegnalazione} from "../../../models/tipoSegnalazione.model";
import {PosizioneSegnalazione} from "../../../models/posizione-segnalazione";
import {Segnalazione} from "../../../models/segnalazione.model";
import {
  LocalizeIssueActivityWidgetComponent
} from "../../../components/localize-issue-activity-widget/localize-issue-activity-widget.component";
import {Sostegno} from "../../../models/sostegno.models";
import {onSnapshot, Unsubscribe} from "firebase/firestore";

@Component({
  selector: 'app-dettagli-segnalazione-dialog',
  templateUrl: './dettagli-segnalazione-dialog.component.html',
  styleUrl: './dettagli-segnalazione-dialog.component.scss'
})
export class DettagliSegnalazioneDialogComponent implements OnInit, OnDestroy {

  @ViewChild(LocalizeIssueActivityWidgetComponent) siglocmap: LocalizeIssueActivityWidgetComponent;

  protected _onDestroy = new Subject<void>();
  protected segnalazione: Segnalazione_Firestore;
  protected modificaSegnalazioneForm: FormGroup;

  private collection_interventi: string = environment.firebase.collection_interventi;
  interventiSegnalazione: Intervento_Firestore;
  hasInterventi: boolean;

  protected showSostegni: boolean = false;

  protected ref: DynamicDialogRef;
  isLoadingResults = false;

  protected areeCompetenza: AreaCompetenza[] = [];
  protected tipiSegnalazione: TipoSegnalazione[] = [];

  public comune: ComuneDTO;
  public mapReady: boolean;
  public hasUpdatedPosition: boolean;
  public mapPosition: PosizioneSegnalazione;
  public sostegniPosition: Sostegno[];

  public isDetail: boolean;
  public dataReady: boolean;

  private idSegnalazione: number;

  private unsubscribeFirestore: Unsubscribe;
  private destroy$ = new Subject<void>();

  protected isSaving = signal(false);

  constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public segnalazioniService: SegnalazioniService,
    public confirmationService: ConfirmationService,
    private messageService: MessageService,
    public dialogService: DialogService,
    private _formBuilder: FormBuilder,
    private firestore: AngularFirestore,
    private userService: UserService,
    private areeCompetenzaService: AreeCompetenzaService,
    private tipiSegnalazioneService: TipiSegnalazioneService,
    private comuneService: ComuniService
  ) {
    this.mapReady = false;
    this.comune = null;
    this.segnalazione = this.config.data["segnalazione"];
    this.idSegnalazione = this.segnalazione.id;
    this.isDetail = !this.config.data["allowEdit"];
    this.dataReady = false;
    this.showSostegni = this.segnalazione.areaDiCompetenza === AreaCompetenzaEnum.PUBBLICA;

    this.modificaSegnalazioneForm = this._formBuilder.group({
      /*  label:          [ this.segnalazione.label],
       descrizione:    [this.segnalazione.descrizione], */
      // comune:         new FormControl({value: this.userService.getUser().comune ? this.userService.getUser().comune.denominazione : null, disabled: true}, Validators.required),
      areaCompetenza: new FormControl({value: null, disabled: true}),
      tipo: new FormControl({value: null, disabled: true}, Validators.required),
      descrizione: new FormControl({value: this.segnalazione.descrizione, disabled: false}),
      segnalatore: new FormControl({value: this.segnalazione.segnalatore, disabled: false}),
    });
    if (this.isDetail) {
      this.modificaSegnalazioneForm.disable()
    }

    this.modificaSegnalazioneForm.get("areaCompetenza").disable();
    if (this.isDetail) {
      this.modificaSegnalazioneForm.get("tipo").disable();
      this.modificaSegnalazioneForm.get("descrizione").disable();
      this.modificaSegnalazioneForm.get("segnalatore").disable();
    }

    this.prepareData();
  }

  ngOnInit(): void {
    // console.log("init form modifica per segnalazione ", this.segnalazione);
    const collectionRef = this.firestore.collection(this.collection_interventi).ref;
    const query = collectionRef.where("codiceSegnalazione", "==", this.segnalazione.codice);
    this.unsubscribeFirestore = onSnapshot(query, (qs) => {
      const interventi = qs.docs.map((item) => {
        const intervento = item.data() as Intervento_Firestore;
        return intervento;
      });
      this.hasInterventi = interventi.length > 0;
      // console.log("update stato interventi for ", this.segnalazione.codice, this.hasInterventi);

      this.loadAreeCompetenza();
    });


  }

  ngOnDestroy() {
    if (this.unsubscribeFirestore) {
      this.unsubscribeFirestore();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  prepareData() {

    this.segnalazioniService.getByID(`${this.idSegnalazione}`)
    .pipe(takeUntil(this.destroy$))
    .subscribe((segnalazioneApi) => {
      // console.log("sig api", segnalazioneApi);
      // console.log("sig fstore ", this.segnalazione);
      this.sostegniPosition = segnalazioneApi.sostegni ?? [];
      this.mapPosition = {
        indirizzo: this.segnalazione.indirizzo ?? null,
        coordinates: this.segnalazione.coordinate && !this.segnalazione.isCoordinateCalculated ? {
          longitudine: this.segnalazione.coordinate.longitude,
          latitudine: this.segnalazione.coordinate.latitude
        } : null,
        sostegni: [...this.sostegniPosition],
        edifici: segnalazioneApi.edifici ?? []
      };
      this.dataReady = true;
    })

    this.comuneService.get()
    .pipe(takeUntil(this.destroy$))
    .subscribe((data: ComuneDTO[]) => {
      // console.log("comune segnalazione", this.segnalazione.codiceISTATComune);
      // console.log("comuni", data);
      this.comune = data.find((comune) => {
        return comune.codiceIstat == this.segnalazione.codiceISTATComune;
      });
      this.mapReady = true;
    });

  }


  loadAreeCompetenza() {
    if (this.userService.getUser().comune) {
      this.areeCompetenza = this.userService.getUser().comune.areeCompetenza;
    } else {
      this.areeCompetenzaService.get()
      .pipe(takeUntil(this.destroy$))
      .subscribe(areeCompetenzaFromDB => {
        this.areeCompetenza = areeCompetenzaFromDB;
        const sigArea = this.areeCompetenza.find((area) => {
          return area.label == this.segnalazione.areaDiCompetenza;
        })
        this.modificaSegnalazioneForm.get("areaCompetenza").setValue(sigArea);
        // if (!(this.hasInterventi || this.isDetail || this.sostegniPosition?.length > 0)) {
        //    this.modificaSegnalazioneForm.get('areaCompetenza')?.enable();
        // }
        this.onAreaCompetenzaSelect(sigArea);

      });
    }
  }

  onAreaCompetenzaSelect(value: AreaCompetenza) {
    if (!value) return;
    
    this.tipiSegnalazioneService.getByAreaCompetenza(value.id)
    .pipe(takeUntil(this.destroy$))
    .subscribe((tipiSegnalazioneFromDB: TipoSegnalazione[]) => {
      this.tipiSegnalazione = tipiSegnalazioneFromDB;
      if (value.label == this.segnalazione.areaDiCompetenza) {
        this.modificaSegnalazioneForm.get("tipo").setValue(this.tipiSegnalazione.find((tiposig) => {
          return tiposig.label == this.segnalazione.tipo;
        }));
      }
    });

    if (!(this.hasInterventi || this.isDetail)) {
      this.modificaSegnalazioneForm.get('tipo')?.enable();
    }
  }

  closeDialog(applyChanges: boolean = false) {
    if (applyChanges && !this.isDetail) {
      this.isSaving.set(true);
      this.modificaSegnalazioneForm.disable();
      let segnalazioneDaModificare = new Segnalazione();
      segnalazioneDaModificare.id = this.segnalazione.id;
      segnalazioneDaModificare.descrizione = this.modificaSegnalazioneForm.get("descrizione").value;
      segnalazioneDaModificare.segnalatore = this.modificaSegnalazioneForm.get("segnalatore").value;
      segnalazioneDaModificare.tipoSegnalazione = this.modificaSegnalazioneForm.get("tipo").value;

      /*if (this.hasUpdatedPosition) {
        segnalazioneDaModificare.indirizzo = this.mapPosition.indirizzo;
        segnalazioneDaModificare.coordinate = {...this.mapPosition.coordinates};
        segnalazioneDaModificare.sostegni = [...this.mapPosition.sostegni];
      }*/

      // console.log("sending ", segnalazioneDaModificare);

      // segnalazioneDaModificare.label = this.modificaSegnalazioneForm.value.label;
      this.segnalazioniService
        .modifica(segnalazioneDaModificare)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (v) => {
            this.dialogRef.close({
              success: true
            });
            this.isSaving.set(false);
          },
          error: (e) => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "info",
              summary: "Errore", life: 10000,
              detail: "Errore in fase di modifica della segnalazione",
            });
            this.dialogRef.close({
              success: false
            });
            this.isSaving.set(false);
          }
        });

    } else {
      this.dialogRef.close(null);
    }

  }

}
